import { cn } from "@/lib/utils";

// Uses Ty's original MR monogram artwork (public/mr-logo.png) directly — no recreation.
export function Logo({ size = 40, showWordmark = true, className }) {
  return (
    <div className={cn("flex items-center gap-3", className)} data-testid="brand-logo">
      <img
        src="/mr-logo.png"
        alt="MR monogram"
        width={size}
        height={size}
        className="rounded-md object-contain"
        style={{ width: size, height: size }}
      />
      {showWordmark && (
        <div className="leading-none">
          <div className="font-display text-lg text-white">The Merch Dash</div>
          <div className="overline mt-0.5">NIL Client Portal</div>
        </div>
      )}
    </div>
  );
}
